import React from 'react';
import { PEIImage } from '@/common';
import { HeaderCta } from './Cta';
import styles from '@/styles/HeaderCtas.module.scss';
import { useAppContext } from '@/components';
import { getCTAS } from '@/utils';

export const HeaderCtas = () => {
  const { state } = useAppContext();
  const ctaBasedOnPartnerShip = (componentName: string, ctas: any) => {
    const subObject = ctas[componentName];
    return subObject['LP/GP'];
  };

  return (
    <span>
      {state.user.loggedIn ? (
        <p
          data-testid='component-header-ctas-name'
          className={styles['welcome-heading']}
        >{`Welcome, ${state.user.name}`}</p>
      ) : (
        <>
          <PEIImage
            src={'./account.svg'}
            alt='account icon'
            width={21}
            height={15}
            className={styles['lock-icon']}
          />
          <HeaderCta
            href={
              state.institutionId
                ? ctaBasedOnPartnerShip('SignIn', getCTAS('', state.institute, state.institutionId))
                : ''
            }
            placeHolder='Sign in or Register'
          />
        </>
      )}
    </span>
  );
};
